'use client';

import type { ReactNode } from 'react';

import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{ removePaddingOnSmallScreen: boolean }>()
  .create(({ theme, removePaddingOnSmallScreen }) => ({
    root: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '1060px',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      ...(removePaddingOnSmallScreen && {
        [theme.breakpoints.down('sm')]: {
          paddingLeft: theme.spacing(0),
          paddingRight: theme.spacing(0),
        },
      }),
      display: 'flex',
      width: '100%',
    },

    mainContent: {
      paddingTop: theme.spacing(2),
    },
  }));

interface Props {
  className?: string;
  children?: ReactNode | null;
  mainContent?: boolean;
  removePaddingOnSmallScreen?: boolean;
}

export const Or2Container = ({
  className,
  children,
  mainContent = true,
  removePaddingOnSmallScreen = true,
}: Props) => {
  const { classes, cx } = useStyles({ removePaddingOnSmallScreen });
  return (
    <div
      className={cx(classes.root, className, {
        [classes.mainContent]: mainContent,
      })}
    >
      {children}
    </div>
  );
};
